import moment from "moment";
import i18n from '@/js/i18n';
import store from "../store";
export default {
  methods: {
    formatDateTh(date) {
      moment.locale("th");
      // let dateTh  = moment().add(543, date).format('LL')
      return moment(date).format("LL");
    },

    increaseDate(date, totalDays) {
      let dateTime = new Date(date).getTime(); //convert string to date time
      let timeStampTotalDay = 3600 * 1000 * 24 * totalDays; //timestamp per day * total increase date

      let dateTimeIncrease = dateTime + timeStampTotalDay;
      moment.locale("th");
      return this.dateTimeTh(dateTimeIncrease);
    },

    //จะ return utc
    increateDateUtc(dateTime, totalIncrease) {
      const lastdate = new Date(dateTime);
      // ประกาศ thedayafterlastdate เป็นวันที่
      const theDayAfterLastdate = lastdate; //ประกาศให้วันตั้งต้นคือวันที่ส่งเข้ามาเพื่อเอาไปบวกหนึ่ง
      
      //Add 1 Day จะได้ค่า 2022-09-25T11:02:49+07:00
      theDayAfterLastdate.setDate(lastdate.getDate() + totalIncrease);

      return theDayAfterLastdate;
    },

    dateTimeTh(datetime) {
      // datetime ที่ส่งเข้ามาต้องเป็นวันที่
      let convertStringToDate = new Date(datetime); //แปลงวันที่
      const datetimeTh = convertStringToDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      return datetimeTh;
    },

    timeThai(datetime) {
      let convertStringToDate = new Date(datetime); //แปลงวันที่
      let time =  convertStringToDate.toLocaleTimeString("th-TH", {
        hour: "numeric",
        minute: "numeric",
      });

      return time
    },

    //ลบเวลา และ return เป็น iso datetime
    diffHour(datetime, hours) {
      //datetime ต้องเป็นวันที่มาแล้ว
      datetime.getTime();
      let diff = datetime - hours * 3600; //return unix time
      let convertUnixtime = new Date(diff);
      return convertUnixtime.toISOString();
    },

    twelveDaysAgo() {
      let start = (Date.now() / 1000) - (3600 * 24) * 12;
      let convertUnixtime = new Date(start * 1000);
      convertUnixtime.toISOString();
      return moment(convertUnixtime).utc().format()
    },

    numberOnly(event) {
      if (!/\d/.test(event.key) && event.key != ".") {
        return event.preventDefault();
      }  
    },
    
    decimalFormat(number) {
      return Intl.NumberFormat('th-TH', {
        currency: 'THB',
        minimumFractionDigits: 0,
      }).format(number)
    },

    datetimeUtc(datetime) {
      return moment(datetime).format('YYYY-MM-DD')
    },

    base64ToBlob(dataURI) {
      var byteString = atob(dataURI.split(",")[1]);
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);

      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: "image/jpg" });
    },

    checkOnlyImage(measure_file) {
      if(measure_file && measure_file.file) {
        if(
          measure_file.file.file_url.includes('_blob') ||
          measure_file.file.file_url.includes('.png') ||
          measure_file.file.file_url.includes('.jpg') ||
          measure_file.file.file_url.includes('.jpeg')
        ) {
          return true;
        } else {
          return false;
        }
      }
    },

    getTimeNow() {
      let currentdate = new Date();
      let hour = ("0" + currentdate.getHours()).slice(-2)
      let minute =("0" + currentdate.getMinutes()).slice(-2)
      // let hour = currentdate.getHours() < 10 ? '0' + currentdate.getHours() : currentdate.getHours()
      // let minute = currentdate.getMinutes() < 10 ? '0' + currentdate.getMinutes() : currentdate.getMinutes()
      let timenow = hour + ":" + minute
      // let timenow = currentdate.getHours() + ":" + currentdate.getMinutes()
      return timenow
    },

    frequencyName(type_id) {
      let type_name = null

      switch (type_id) {
        case 0 : type_name = 'กรอกแบบรายวัน'
        break;
        case 1 : type_name = 'กรอกแบบรายเดือน'
        break;
        case 2 : type_name = 'กรอกแบบรายปี'
        break;
      }

      return type_name;
    },

    inputTypeName(type_id) {
      let type_name = null

      switch (type_id) {
        case 0 : type_name = i18n.t('TXT_INPUT_USAGE');
        break;
        case 1 : type_name = i18n.t('TXT_INPUT_ACCUMULATE');
        break;
      }

      return type_name;
    },

    roleUserId(role) {
      let role_id = 0
      switch(role) {
        case "Super Admin" : role_id = 1000;
        break;
        case "Admin" : role_id = 100;
        break;
        case "Importer" : role_id = 1;
        break;
        case "Viewer" : role_id = 0;
        break;
      }
      return role_id;
    },

    successAlert(word) {
      this.$swal({
        icon: "success",
        text: word,
        showConfirmButton: false,
        timer: 1500
      });
    },

    monthYearThai(datetime) {
      // datetime ที่ส่งเข้ามาต้องเป็นวันที่
      let convertStringToDate = new Date(datetime); //แปลงวันที่
      const datetimeTh = convertStringToDate.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "long",
      });

      return datetimeTh;
    },

    numberWithCommas(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    monthTh(datetime) {
      // datetime ที่ส่งเข้ามาต้องเป็นวันที่
      if (datetime) {
        let dateLang = "en-ZA";
        let convertStringToDate = new Date(datetime); //แปลงวันที่
        let month = convertStringToDate.toLocaleString(dateLang, {
          month: "long",
        });
        let year = convertStringToDate.getFullYear();
        let formattedDate = `${month} ${year}`;

        return formattedDate;
      }
    },

    setFormatDateTime() {
      return {
        stringify: (date) => {
          if (date && date.start && date.end) {
            return `${this.monthTh(date.start)} - ${this.monthTh(date.end)}`;
          } else if (date) {
            return this.monthTh(date);
          } else {
            return null;
          }
        },
      };
    },

    decimalNotRounded(number) {
      let value = null;
      if (typeof number != "string") {
        value = number;
      } else {
        if (this.isCommaFormat(number) == true) {
          value = Number(number.replace(/,/g, ""));
        } else {
          value = Number(number);
        }
      }
      if (value % 1 == 0) {
        return this.decimalFormat(value.toFixed(2));
      } else {
        return this.decimalFormat(
          Number(value.toString().match(/^\d+(?:\.\d{0,2})?/))
        );
      }
    },
    formatThaiDate (d) {
      let date = new Date(d)

      const months = [
        "ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.",
        "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."
      ];
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      return `${month} ${year}`;
    },

    setFormatDate() {
      return {
        stringify: (date) => {
          if (!date) return ''
          
          const d = new Date(date)
          const options = { month: 'long', day: 'numeric' }
          let lang = store.state.selectLang.lang;
          let dateLang = lang == "th" ? "th-TH" : "en-ZA";
          const formatter = new Intl.DateTimeFormat(dateLang, options)
          
          const dayMonthThai = formatter.format(d)   // เช่น "12 มิถุนายน"
          const yearCE = d.getFullYear()             // ปี ค.ศ.

          return `${dayMonthThai} ${yearCE}`         // เช่น "12 มิถุนายน 2024"
        },
        parse: (value) => {
          // สมมุติ value เป็น "12 มิถุนายน 2024"
          return new Date(value)
        }
      }
    },

    
    precision(value, p) {
      if (value === "") {
        return "";
      } else {
        const num = Number(value.replace(/,/g, ""));
        return +(Math.round(num + `e+${p}`) + `e-${p}`);
      }
    },

    // 16 Dec 2025
    convertShortDate(isoString) {
      const date = new Date(isoString);

      // ดึงวันที่และเดือน แบบภาษาไทย (ไม่รวมปี)
      const dayMonth = date.toLocaleDateString('th-TH', {
        day: '2-digit',
        month: 'short',
        year: undefined  // ไม่เอาปีในนี้
      });

      // ดึงปีแบบค.ศ.
      const year = date.getFullYear();

      // รวมเป็นสตริง (เช่น "12 มิ.ย. 2024")
      return `${dayMonth} ${year}`;
    },


    // ใช้วันที่ที่เลือก + เวลาที่เป็นปัจจุบัน
    convertDateCurrentTime(date) {
      const currentTime = new Date();

    // ผสมวันที่ของ date เข้ากับเวลา ณ ปัจจุบัน
      const combined = moment(date)
        .set({
          hour: currentTime.getHours(),
          minute: currentTime.getMinutes(),
          second: currentTime.getSeconds(),
        });

      return moment(combined).format();
    },

    disableOutOfRangeDates(date) {
      const minDate = new Date(2000, 0, 1) // 1 มกราคม 2000
      const today = new Date()

      return date < minDate || date > today
      // const today = new Date();
      // today.setHours(0, 0, 0, 0);
      // return date > today;
    },
    dateTimeThShort(date_time) {
      // date_time ที่ส่งเข้ามาต้องเป็นวันที่
      if (date_time) {
        let lang = store.state.selectLang.lang;
        let dateLang = lang == "th" ? "th-TH" : "en-ZA";
        let convertStringToDate = new Date(date_time); //แปลงวันที่
        // let day = convertStringToDate.getDate();
        let month = convertStringToDate.toLocaleString(dateLang, {
          month: "short",
        });
        let year = convertStringToDate.getFullYear();
        let formattedDate = `${month} ${year}`;

        return formattedDate;
      }
    },
    setFormatMonth() {
      return this.createDateFormatter(this.dateTimeThShort);
    },
    createDateFormatter(formatFn) {
      return {
        stringify: (date) => {
          if (date?.start && date?.end) {
            return `${formatFn(date.start)} - ${formatFn(date.end)}`;
          } else if (date) {
            return formatFn(date);
          }
          return null;
        },
      };
    },
  },
};
